<template>
<div id="app">
  <div class="header">
    <span class="bold_header">CSS-</span><span class="normal_header">Table</span>
    <button class="tab_button" type="button" name="button" @click="option_tab('font')" v-bind:class="{ tab_button_active: font }">Font</button>
    <button class="tab_button" type="button" name="button" @click="option_tab('general')" v-bind:class="{ tab_button_active: general }">General</button>
  </div>
  <div class="home">
    <div class="row home_content">
      <div class="options col-sm-12 col-lg-6 col-md-6 text-left">
        <div id="general" v-if="general == true">
          <div class="row">
            <div class="col">
              <h5>Basic</h5>
              <span>Header</span>
              <select class="" name="" v-model="header_position">
                <option value="top">Top</option>
                <option value="left">left</option>
              </select>
            </div>
            <div class="col">

            </div>
            <div class="col">
            </div>
          </div>
          <br>
          <div class="">
            <div class="row t_border">
              <div class="col">
                <h5>Border</h5>
                <span>Table</span> <br>
                <input type="number" maxlength="2" min="0" max="20" id="border_table_size" @input="maxLengthCheck" v-model="border_table_size">
                <select class="" name="" v-model="border_table_type">
                  <option value="Dotted">Dotted</option>
                  <option value="dashed">dashed</option>
                  <option value="solid">solid</option>
                  <option value="double">double</option>
                </select>
                <select class="" name="" v-model="border_table_position">
                  <option value="border">Full</option>
                  <option value="border-left">Left</option>
                  <option value="border-right">Right</option>
                  <option value="border-top">Top</option>
                  <option value="border-bottom">Bottom</option>
                </select>
                <swatches v-model="border_color_table" show-fallback popover-to="right" row-length="10" style="float:right;padding-right:60px;"></swatches>
                <br>
                <span>Th</span> <br>
                <input type="number" maxlength="2" min="0" max="20" id="border_th_size" @input="maxLengthCheck" v-model="border_th_size">
                <select class="" name="" v-model="border_th_type">
                  <option value="Dotted">Dotted</option>
                  <option value="dashed">dashed</option>
                  <option value="solid">solid</option>
                  <option value="double">double</option>
                </select>
                <select class="" name="" v-model="border_th_position">
                  <option value="border">Full</option>
                  <option value="border-left">Left</option>
                  <option value="border-right">Right</option>
                  <option value="border-top">Top</option>
                  <option value="border-bottom">Bottom</option>
                </select>
                <swatches v-model="border_color_th" show-fallback popover-to="right" row-length="10" style="float:right;padding-right:60px;"></swatches>
                <br>
                <span>Td</span> <br>
                <input type="number" maxlength="2" min="0" max="20" id="border_td_size" @input="maxLengthCheck" v-model="border_td_size">
                <select class="" name="" v-model="border_td_type">
                  <option value="Dotted">Dotted</option>
                  <option value="dashed">dashed</option>
                  <option value="solid">solid</option>
                  <option value="double">double</option>
                </select>
                <select class="" name="" v-model="border_td_position">
                  <option value="border">Full</option>
                  <option value="border-left">Left</option>
                  <option value="border-right">Right</option>
                  <option value="border-top">Top</option>
                  <option value="border-bottom">Bottom</option>
                </select>
                <swatches v-model="border_color_td" show-fallback popover-to="right" row-length="10" style="float:right;padding-right:60px;"></swatches>
                <div class="collapse_div">
                  <span>Collapse border&nbsp;</span>
                  <select class="" name="" v-model="border_table_model">
                    <option value="">Collapse</option>
                    <option value="separate">Separate</option>
                  </select>
                </div>
              </div>
              <div class="col hide_md">

              </div>
            </div>
          </div>
          <br>
          <div class="">
            <div class="row">

              <div class="col t_padding">
                <h5>Padding</h5>
                <span>Th <br> Top and bottm<span class="hidden_text">ti</span></span>
                <input type="number" maxlength="2" min="0" max="25" id="padding_th_size_tb" @input="maxLengthCheck" v-model="padding_th_size_tb">
                <br>
                <span>Left and right<span class="hidden_text">TH</span></span>
                <input type="number" maxlength="2" min="0" max="25" id="padding_th_size_lr" @input="maxLengthCheck" v-model="padding_th_size_lr">
              </div>
              <div class="col t_padding">
                <h5>&nbsp;</h5>
                <span>Td <br> Top and bottm<span class="hidden_text">ti</span></span>
                <input type="number" maxlength="2" min="0" max="25" id="padding_td_size_tb" @input="maxLengthCheck" v-model="padding_td_size_tb">
                <br>
                <span>Left and right<span class="hidden_text">TH</span></span>
                <input type="number" maxlength="2" min="0" max="25" id="padding_td_size_lr" @input="maxLengthCheck" v-model="padding_td_size_lr">
              </div>
              <div class="col">

              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-4">
                <h5>Background color</h5>
                <span style="float:left;">Table</span>
                <span>
                  <swatches v-model="background_color_table" show-fallback popover-to="right" row-length="10" style="margin-bottom:4px;"></swatches>
                </span>
                <span style="float:left;">Th<span class="hidden_text">Yiii</span></span>
                <swatches v-model="background_color_th" show-fallback popover-to="right" row-length="10" style="margin-bottom:4px;"></swatches>
                <span style="float:left;">Td<span class="hidden_text">Yiii</span></span>
                <swatches v-model="background_color_td" show-fallback popover-to="right" row-length="10" style="margin-bottom:4px;"></swatches>

              </div>
              <div class="col">
                <h5>&nbsp;</h5>
                <span>Table Gradient</span>
                <br>
                <swatches v-model="background_color_table_g1" show-fallback popover-to="right" row-length="10" style="float:left"></swatches><span style="float:left">&nbsp;&nbsp; </span>
                &nbsp; <swatches v-model="background_color_table_g2" show-fallback popover-to="right" row-length="10" style="float:left"></swatches>
                <select class="" name="" v-model="gradient_direction">
                  <option value="to bottom">Top to bottom</option>
                  <option value="to top">Bottom to top</option>
                  <option value="to right">Left to right</option>
                  <option value="to left">Right to left</option>
                </select>
              </div>

            </div>


          </div>

        </div>

        <div id="font" v-if="font == true">
          <div class="row">
            <div class="col t_fontsize">
              <h5>Font size</h5>
              <span>Th&nbsp;</span>
              <input type="number" maxlength="2" min="1" max="30" id="text_size_th" @input="maxLengthCheck" v-model="text_size_th">
              <br>
              <span>Td&nbsp;</span>
              <input type="number" maxlength="2" min="1" max="30" id="text_size_td" @input="maxLengthCheck" v-model="text_size_td">
            </div>
            <div class="col t_margin_bottom">
              <h5>Font weight</h5>
              <span>Th&nbsp;</span>
              <select class="" name="" v-model="text_weight_th">
                <option value=""></option>
                <option value="normal">Normal</option>
                <option value="bold">Bold</option>
                <option value="900">Bolder</option>
              </select>
              <br>
              <span>Td&nbsp;</span>
              <select class="" name="" v-model="text_weight_td">
                <option value=""></option>
                <option value="normal">Normal</option>
                <option value="bold">Bold</option>
                <option value="900">Bolder</option>
              </select>
            </div>
            <div class="col font_family_MT t_margin_bottom">
              <h5>Font family</h5>
              <span>Th&nbsp;</span>
              <select class="" name="" v-model="font_family_th" style="max-width:60%">
                <option value=""></option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Arial">Arial</option>
              </select>
              <br>
              <span>Th&nbsp;</span>
              <select class="" name="" v-model="font_family_td" style="max-width:60%">
                <option value=""></option>
                <option value="Times New Roman">Times New Roman</option>
                <option value="Arial">Arial</option>
              </select>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col ">
              <h5>Text color</h5>
              <span style="float:left">Th&nbsp;</span>
              <swatches v-model="text_color_th" show-fallback popover-to="right" row-length="10" style="margin-bottom:4px;"></swatches>
              <span style="float:left">Td&nbsp;</span>
              <swatches v-model="text_color_td" show-fallback popover-to="right" row-length="10" style="margin-bottom:4px;"></swatches>
            </div>
            <div class="col t_margin_bottom">
              <h5>Text style</h5>
              <span>Th&nbsp;</span>
              <select class="" name="" v-model="text_style_th">
                <option value=""></option>
                <option value="normal">Normal</option>
                <option value="italic">Italic</option>
              </select>
              <br>
              <span>Td&nbsp;</span>
              <select class="" name="" v-model="text_style_td">
                <option value=""></option>
                <option value="normal">Normal</option>
                <option value="italic">Italic</option>
              </select>
            </div>
            <div class="col t_margin_bottom">
              <h5>Text align</h5>
              <span>Th&nbsp;</span>
              <select class="" name="" v-model="text_align_th">
                <option value=""></option>
                <option value="left">Left</option>
                <option value="right">Right</option>
                <option value="center">Center</option>
              </select>
              <br>
              <span>Td&nbsp;</span>
              <select class="" name="" v-model="text_align_td">
                <option value=""></option>
                <option value="left">Left</option>
                <option value="right">Right</option>
                <option value="center">Center</option>
              </select>
            </div>
          </div>
          <br>
          <div class="row">
            <div class="col t_margin_bottom">
              <h5>Text transform</h5>
              <span>Th&nbsp;</span>
              <select class="" name="" v-model="text_transform_th">
                <option value=""></option>
                <option value="uppercase">Uppercase</option>
                <option value="lowercase">Lowercase</option>
                <option value="capitalize">Capitalize</option>
              </select>
              <br>
              <span>Td&nbsp;</span>
              <select class="" name="" v-model="text_transform_td">
                <option value=""></option>
                <option value="uppercase">Uppercase</option>
                <option value="lowercase">Lowercase</option>
                <option value="capitalize">Capitalize</option>
              </select>
            </div>
            <div class="col">

            </div>
            <div class="col">

            </div>
          </div>
        </div>

      </div>
      <div class="table_preview col-sm-12 col-lg-6 col-md-6 text-center">
        <table v-if="header_position=='top'"
          v-bind:style="border_table_position+':'+border_table_size+'px '+border_table_type+' '+border_color_table+';'+'border-collapse:'+border_table_model+';'+'background-color:'+background_color_table+';'+gradient_bg">
          <thead v-bind:style="'font-family:'+font_family_th">
            <tr>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th">
                head</th>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th">
                head</th>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th">
                head</th>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th">
                head</th>
            </tr>
          </thead>
          <tbody v-bind:style="'font-family:'+font_family_td">
            <tr>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
            </tr>
            <tr>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
            </tr>
            <tr>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
            </tr>
            <tr>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                cell</td>
            </tr>

          </tbody>
        </table>

        <table v-if="header_position=='left'" v-bind:style="border_table_position+':'+border_table_size+'px '+border_table_type+' '+border_color_table+';'+'border-collapse:'+border_table_model+';'+'background-color:'+background_color_table">
          <tbody>
            <tr>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th+';'+'font-family:'+font_family_th">
                Head</th>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
            </tr>
            <tr>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th+';'+'font-family:'+font_family_th">
                Head</th>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
            </tr>
            <tr>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th+';'+'font-family:'+font_family_th">
                Head</th>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
            </tr>
            <tr>
              <th
                v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th+';'+'font-family:'+font_family_th">
                Head</th>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
              <td
                v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                Cell</td>
            </tr>

          </tbody>
        </table>

      </div>
    </div>
    <div class="">
      <div class="content">
        <div class="row code_menu text-center">
          <div class="col">
            Rows <input type="number" maxlength="2" min="4" max="20" id="rows" @input="maxLengthCheck" v-model="rows">

          </div>
          <div class="col">
            Columns <input type="number" maxlength="2" min="4" max="20" id="columns" @input="maxLengthCheck" v-model="columns">

          </div>
          <div class="col">
            <span>Inline Css</span>
            <input type="checkbox" name="" value="" v-model="inline_css">

          </div>
          <div class="col">
            <button type="button" class="copy_code_btn" name="button" @click="copy()">Copy code</button>

          </div>


        </div>
        <div class="text-center">

          <div class="code_div" id="table_code_i" v-bind:class="{ 'none': !inline_css }">
          </div>
          <div class="code_div" id="table_code_s" v-bind:class="{ 'none': inline_css }">

          </div>
          <div id="dynamic_table_i" style="display:none;">
            <table v-if="header_position=='top'"
              v-bind:style="border_table_position+':'+border_table_size+'px '+border_table_type+' '+border_color_table+';'+'border-collapse:'+border_table_model+';'+'background-color:'+background_color_table+';'+gradient_bg"> <br>
              <thead v-bind:style="'font-family:'+font_family_th"> <br>
                <tr>
                  <th v-for="column in Number(columns)" :key="column"
                    v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th">
                  </th>
                </tr>
              </thead> <br>
              <tbody v-bind:style="'font-family:'+font_family_td"> <br>
                <tr v-for="row in Number(rows)" :key="row">
                  <td v-for="column in Number(columns)" :key="column"
                    v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td">
                  </td>
                </tr>
              </tbody> <br>
            </table>

            <table v-if="header_position=='left'" v-bind:style="border_table_position+':'+border_table_size+'px '+border_table_type+' '+border_color_table+';'+'border-collapse:'+border_table_model+';'+'background-color:'+background_color_table"> <br>
              <tbody> <br>
                <tr v-for="row in Number(rows)" :key="row">
                  <th
                    v-bind:style="border_th_position+':'+border_th_size+'px '+border_th_type+' '+border_color_th+';'+'padding-top:'+padding_th_size_tb+'px'+';'+'padding-bottom:'+padding_th_size_tb+'px'+';'+'padding-left:'+padding_th_size_lr+'px'+';'+'padding-right:'+padding_th_size_lr+'px'+';'+'background-color:'+background_color_th+';'+'color:'+text_color_th+';'+'font-size:'+text_size_th+'px'+';'+'font-weight:'+text_weight_th+';'+'font-style:'+text_style_th+';'+'text-transform:'+text_transform_th+';'+'text-align:'+text_align_th+';'+'font-family:'+font_family_th">
                  </th>
                  <td v-for="column in Number(columns)" :key="column"
                    v-bind:style="border_td_position+':'+border_td_size+'px '+border_td_type+' '+border_color_td+';'+'padding-top:'+padding_td_size_tb+'px'+';'+'padding-bottom:'+padding_td_size_tb+'px'+';'+'padding-left:'+padding_td_size_lr+'px'+';'+'padding-right:'+padding_td_size_lr+'px'+';'+'background-color:'+background_color_td+';'+'color:'+text_color_td+';'+'font-size:'+text_size_td+'px'+';'+'font-weight:'+text_weight_td+';'+'font-style:'+text_style_td+';'+'text-transform:'+text_transform_td+';'+'text-align:'+text_align_td+';'+'font-family:'+font_family_td">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div id="dynamic_table_s" style="display:none;">
            <code v-if="header_position=='top'">
              .css-table {
              <span v-if="border_table_size != ''">{{border_table_position}}:{{border_table_size}}px {{border_table_type}} {{border_color_table}};</span>
              <span v-if="border_table_model != ''">border-collapse:{{border_table_model}};</span>
              <span v-if="background_color_table != ''">background-color:{{background_color_table}};</span>
              <span v-if="gradient_bg != ''">{{gradient_bg}};</span>
              }
              .css-table thead {
              <span v-if="font_family_th != ''">font-family:{{font_family_th}};</span>
              }
              .css-table th {
              <span v-if="border_th_size != ''">{{border_th_position}}:{{border_th_size}}px {{border_th_type}} {{border_color_th}};</span>
              <span v-if="padding_th_size_tb != ''">padding-top:{{padding_th_size_tb}}px;</span>
              <span v-if="padding_th_size_tb != ''">padding-bottom:{{padding_th_size_tb}}px;</span>
              <span v-if="padding_th_size_lr != ''"> padding-left:{{padding_th_size_lr}}px;</span>
              <span v-if="padding_th_size_lr != ''"> padding-right:{{padding_th_size_lr}}px;</span>
              <span v-if="background_color_th !=''">background-color:{{background_color_th}};</span>
              <span v-if="text_color_th != ''">color:{{text_color_th}};</span>
              <span v-if="text_size_th != ''">font-size:{{text_size_th}}px;</span>
              <span v-if="text_weight_th != ''">font-weight:{{text_weight_th}};</span>
              <span v-if="text_style_th != ''">font-style:{{text_style_th}};</span>
              <span v-if="text_transform_th != ''"> text-transform:{{text_transform_th}};</span>
              <span v-if="text_align_th != ''">text-align:{{text_align_th}};</span>
              }
              .css-table tbody{
              <span v-if="font_family_td != ''">font-family:{{font_family_td}};</span>
              }
              .css-table td{
              <span v-if="border_td_size != ''">border_td_position:{{border_td_size}}px {{border_td_type}} {{border_color_td}};</span>
              <span v-if="padding_td_size_tb != ''">padding-top:{{padding_td_size_tb}}px;</span>
              <span v-if="padding_td_size_tb != ''">padding-bottom:{{padding_td_size_tb}}px;</span>
              <span v-if="padding_td_size_lr != ''"> padding-left:{{padding_td_size_lr}}px;</span>
              <span v-if="padding_td_size_lr != ''"> padding-right:{{padding_td_size_lr}}px;</span>
              <span v-if="background_color_td != ''"> background-color:{{background_color_td}};</span>
              <span v-if="text_color_td != ''"> color:{{text_color_td}};</span>
              <span v-if="text_size_td != ''"> font-size:{{text_size_td}}px;</span>
              <span v-if="text_weight_td != ''"> font-weight:{{text_weight_td}};</span>
              <span v-if="text_style_td != ''"> font-style:{{text_style_td}};</span>
              <span v-if="text_transform_td != ''"> text-transform:{{text_transform_td}};</span>
              <span v-if="text_align_td != ''"> text-align:{{text_align_td}};</span>
              }
            </code>
            <code v-if="header_position=='left'">
              .css-table {
              <span v-if="border_table_size != ''"> {{border_table_position}}:{{border_table_size}}px {{border_table_type}} {{border_color_table}}; </span>
              <span v-if="border_table_model != ''"> border-collapse:{{border_table_model}}; </span>
              <span v-if="background_color_table != ''"> background-color:{{background_color_table}}; </span>
              }
              .css-table th {
              <span v-if="border_th_size != ''"> {{border_th_position}}:{{border_th_size}}px {{border_th_type}} {{border_color_th}}; </span>
              <span v-if="padding_th_size_tb != ''"> padding-top:{{padding_th_size_tb}}px; </span>
              <span v-if="padding_th_size_tb != ''"> padding-bottom:{{padding_th_size_tb}}px; </span>
              <span v-if="padding_th_size_lr != ''"> padding-left:{{padding_th_size_lr}}px; </span>
              <span v-if="padding_th_size_lr != ''"> padding-right:{{padding_th_size_lr}}px; </span>
              <span v-if="background_color_th != ''"> background-color:{{background_color_th}}; </span>
              <span v-if="text_color_th != ''"> color:{{text_color_th}}; </span>
              <span v-if="text_size_th != ''"> font-size:{{text_size_th}}px; </span>
              <span v-if="text_weight_th != ''"> font-weight:{{text_weight_th}}; </span>
              <span v-if="text_style_th != ''"> font-style:{{text_style_th}}; </span>
              <span v-if="text_transform_th != ''"> text-transform:{{text_transform_th}}; </span>
              <span v-if="text_align_th != ''"> text-align:{{text_align_th}}; </span>
              <span v-if="font_family_th != ''"> font-family:{{font_family_th}}; </span>
              }
              .css-table td {
              <span v-if="border_td_size != ''"> {{border_td_position}}:{{border_td_size}}px {{border_td_type}} {{border_color_td}}; </span>
              <span v-if="padding_td_size_tb != ''"> padding-top:{{padding_td_size_tb}}px; </span>
              <span v-if="padding_td_size_tb != ''"> padding-bottom:{{padding_td_size_tb}}px; </span>
              <span v-if="padding_td_size_lr != ''"> padding-left:{{padding_td_size_lr}}px; </span>
              <span v-if="padding_td_size_lr != ''"> padding-right:{{padding_td_size_lr}}px; </span>
              <span v-if="background_color_td != ''"> background-color:{{background_color_td}}; </span>
              <span v-if="text_color_td != ''"> color:{{text_color_td}}; </span>
              <span v-if="text_size_td != ''"> font-size:{{text_size_td}}px; </span>
              <span v-if="text_weight_td != ''"> font-weight:{{text_weight_td}}; </span>
              <span v-if="text_style_td != ''"> font-style:{{text_style_td}}; </span>
              <span v-if="text_transform_td != ''"> text-transform:{{text_transform_td}}; </span>
              <span v-if="text_align_td != ''"> text-align:{{text_align_td}}; </span>
              <span v-if="font_family_td != ''"> font-family:{{font_family_td}}; </span>
              }
            </code>
            <br>
            <table v-if="header_position=='top'" class="css-table"> <br>
              <thead> <br>
                <tr>
                  <th v-for="column in Number(columns)" :key="column">
                  </th>
                </tr>
              </thead> <br>
              <tbody> <br>
                <tr v-for="row in Number(rows)" :key="row">
                  <td v-for="column in Number(columns)" :key="column">
                  </td>
                </tr>
              </tbody> <br>
            </table>

            <table v-if="header_position=='left'" class="css-table"> <br>
              <tbody> <br>
                <tr v-for="row in Number(rows)" :key="row">
                  <th>
                  </th>
                  <td v-for="column in Number(columns)" :key="column">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
  <div class="footer text-center">
    © 2019 www.css-table.com
  </div>

</div>
</template>

<script>
import Swatches from 'vue-swatches'

import "vue-swatches/dist/vue-swatches.min.css"

export default {
  name: 'app',
  components: {
    Swatches
  },
  data() {
    return {
      general: true,
      font: false,
      rows: '4',
      columns: '4',
      inline_css: true,

      header_position: 'top',
      border_table_size: '',
      border_table_type: 'solid',
      border_table_position: 'border',
      border_th_size: '',
      border_th_type: 'solid',
      border_th_position: 'border',
      border_td_size: '',
      border_td_type: 'solid',
      border_td_position: 'border',
      border_color_table: '#000000',
      border_color_th: '#000000',
      border_color_td: '#000000',
      border_table_model: '',

      padding_th_size_tb: '',
      padding_th_size_lr: '',
      padding_td_size_tb: '',
      padding_td_size_lr: '',

      text_size_th: '16',
      text_size_td: '16',
      text_weight_th: 'bold',
      text_weight_td: '',
      text_transform_th: '',
      text_transform_td: '',
      text_style_th: '',
      text_style_td: '',
      text_align_th: '',
      text_align_td: '',
      font_family_th: '',
      font_family_td: '',

      text_color_th: '#000000',
      text_color_td: '#000000',
      background_color_table: '',
      background_color_th: '',
      background_color_td: '',
      background_color_table_g1: '',
      background_color_table_g2: '',
      gradient_direction: 'to right',
      gradient_bg: '',
    };
  },
  mounted() {
    var dynamic_table_code_i = document.getElementById('dynamic_table_i').innerHTML;
    var dynamic_table_string_i = dynamic_table_code_i.replace(/<br>/g, "\n");

    dynamic_table_string_i = dynamic_table_string_i.replace(/<tbody>/g, "\xa0\xa0\xa0<tbody>");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<thead>/g, "\xa0\xa0\xa0<thead>");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<\/thead>/g, "\xa0\xa0\xa0</thead>\n");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<\/tbody>/g, "\xa0\xa0\xa0</tbody>");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0<tr>");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<\/tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0</tr>");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<th /g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<th ");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<td /g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<td ");

    dynamic_table_string_i = dynamic_table_string_i.replace(/<\/th>/g, "</th>\n");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<\/td>/g, "</td>\n");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<\/tr>/g, "</tr>\n");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<tr>/g, "<tr>\n");
    dynamic_table_string_i = dynamic_table_string_i.replace(/<!---->/g, "");
    document.getElementById('table_code_i').innerText = dynamic_table_string_i;

    var dynamic_table_code_s = document.getElementById('dynamic_table_s').innerHTML;
    var dynamic_table_string_s = dynamic_table_code_s.replace(/<br>/g, "\n");

    dynamic_table_string_s = dynamic_table_string_s.replace(/<tbody>/g, "\xa0\xa0\xa0<tbody>");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<thead>/g, "\xa0\xa0\xa0<thead>");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<\/thead>/g, "\xa0\xa0\xa0</thead>\n");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<\/tbody>/g, "\xa0\xa0\xa0</tbody>");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0<tr>");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<\/tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0</tr>");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<th>/g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<th>");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<td>/g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<td>");

    dynamic_table_string_s = dynamic_table_string_s.replace(/<\/th>/g, "</th>\n");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<\/td>/g, "</td>\n");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<\/tr>/g, "</tr>\n");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<tr>/g, "<tr>\n");
    dynamic_table_string_s = dynamic_table_string_s.replace(/<!---->/g, "");
    document.getElementById('table_code_s').innerText = dynamic_table_string_s;

  },
  methods: {
    copy() {
      if (this.inline_css == true) {
        var elm_1 = document.getElementById("table_code_i");
        if (document.body.createTextRange) {
          var range_1 = document.body.createTextRange();
          range_1.moveToElementText(elm_1);
          range_1.select();
          document.execCommand("Copy");
        } else if (window.getSelection) {
          var selection_1 = window.getSelection();
          var range_2 = document.createRange();
          range_2.selectNodeContents(elm_1);
          selection_1.removeAllRanges();
          selection_1.addRange(range_2);
          document.execCommand("Copy");
        }
      } else if (this.inline_css == false) {
        var elm_2 = document.getElementById("table_code_s");
        if (document.body.createTextRange) {
          var range_3 = document.body.createTextRange();
          range_3.moveToElementText(elm_2);
          range_3.select();
          document.execCommand("Copy");
        } else if (window.getSelection) {
          var selection_2 = window.getSelection();
          var range_4 = document.createRange();
          range_4.selectNodeContents(elm_2);
          selection_2.removeAllRanges();
          selection_2.addRange(range_4);
          document.execCommand("Copy");
        }
      }

    },
    update_code() {
      setTimeout(function() {
        var dynamic_table_code_i = document.getElementById('dynamic_table_i').innerHTML;
        var dynamic_table_string_i = dynamic_table_code_i.replace(/<br>/g, "\n");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<tbody>/g, "\xa0\xa0\xa0<tbody>");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<thead>/g, "\xa0\xa0\xa0<thead>");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<\/thead>/g, "\xa0\xa0\xa0</thead>\n");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<\/tbody>/g, "\xa0\xa0\xa0</tbody>");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0<tr>");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<\/tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0</tr>");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<th /g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<th ");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<td /g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<td ");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<\/th>/g, "</th>\n");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<\/td>/g, "</td>\n");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<\/tr>/g, "</tr>\n");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<tr>/g, "<tr>\n");
        dynamic_table_string_i = dynamic_table_string_i.replace(/<!---->/g, "");
        document.getElementById('table_code_i').innerText = dynamic_table_string_i;

        var dynamic_table_code_s = document.getElementById('dynamic_table_s').innerHTML;
        var dynamic_table_string_s = dynamic_table_code_s.replace(/<br>/g, "\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<tbody>/g, "\xa0\xa0\xa0<tbody>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<thead>/g, "\xa0\xa0\xa0<thead>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/thead>/g, "\xa0\xa0\xa0</thead>\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/tbody>/g, "\xa0\xa0\xa0</tbody>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0<tr>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/tr>/g, "\xa0\xa0\xa0\xa0\xa0\xa0</tr>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<th>/g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<th>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<td>/g, "\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0<td>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/th>/g, "</th>\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/td>/g, "</td>\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/tr>/g, "</tr>\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<tr>/g, "<tr>\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<!---->/g, "");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<span>/g, "\xa0\xa0\xa0\xa0\xa0\xa0");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/span>/g, "\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<code>/g, "<style>");
        dynamic_table_string_s = dynamic_table_string_s.replace(/<\/code>/g, "</style>\n");
        dynamic_table_string_s = dynamic_table_string_s.replace(/\.css/g, "\xa0\xa0\xa0.css");
        dynamic_table_string_s = dynamic_table_string_s.replace(/}/g, "\xa0\xa0\xa0}");
        document.getElementById('table_code_s').innerText = dynamic_table_string_s;
      }, 100).this;
    },
    maxLengthCheck(e) {
      if (Number(this[e.target.id]) > Number(e.target.maxLength)) {
        this[e.target.id] = this[e.target.id].slice(0, Number(e.target.maxLength));
      }
      if (Number(this[e.target.id]) > Number(e.target.max)) {
        this[e.target.id] = e.target.max;
      }
      if (Number(this[e.target.id]) < Number(e.target.min) && Number(e.target.min) != 0) {
        this[e.target.id] = e.target.min;
      }
    },

    option_tab(to) {
      if (to == 'font') {
        this.font = true;
        this.general = false;
      } else if (to == 'general') {
        this.font = false;
        this.general = true;
      }
    }
  },
  watch: {
    background_color_table: function(new_value) {
      this.update_code()
      if (new_value != '') {
        this.gradient_bg = '';
        this.background_color_table_g1 = '';
        this.background_color_table_g2 = '';
        this.gradient_direction = 'to bottom';
      }
    },
    background_color_table_g1: function(new_value) {
      this.update_code()
      if (new_value != '') {
        this.background_color_table = '';
        this.gradient_bg = 'background-image: linear-gradient(' + this.gradient_direction + ',' + this.background_color_table_g1 + ',' + this.background_color_table_g2;
      }
    },
    background_color_table_g2: function(new_value) {
      this.update_code()
      if (new_value != '') {
        this.background_color_table = '';
        this.gradient_bg = 'background-image: linear-gradient(' + this.gradient_direction + ',' + this.background_color_table_g1 + ',' + this.background_color_table_g2;
      }
    },
    gradient_direction: function(new_value) {
      this.update_code()
      if (new_value != 'to bottom') {
        this.background_color_table = '';
        this.gradient_bg = 'background-image: linear-gradient(' + this.gradient_direction + ',' + this.background_color_table_g1 + ',' + this.background_color_table_g2;
      }
    },
    inline_css: function() {
      this.update_code()
    },
    rows: function() {
      this.update_code()
    },
    columns: function() {
      this.update_code()
    },
    header_position: function() {
      this.update_code()
    },
    border_table_size: function() {
      this.update_code()
    },
    border_table_type: function() {
      this.update_code()
    },
    border_table_position: function() {
      this.update_code()
    },
    border_th_size: function() {
      this.update_code()
    },
    border_th_type: function() {
      this.update_code()
    },
    border_th_position: function() {
      this.update_code()
    },
    border_td_size: function() {
      this.update_code()
    },
    border_td_type: function() {
      this.update_code()
    },
    border_td_position: function() {
      this.update_code()
    },
    border_color_table: function() {
      this.update_code()
    },
    border_color_th: function() {
      this.update_code()
    },
    border_color_td: function() {
      this.update_code()
    },
    border_table_model: function() {
      this.update_code()
    },
    padding_th_size_tb: function() {
      this.update_code()
    },
    padding_th_size_lr: function() {
      this.update_code()
    },
    padding_td_size_tb: function() {
      this.update_code()
    },
    padding_td_size_lr: function() {
      this.update_code()
    },
    text_size_th: function() {
      this.update_code()
    },
    text_size_td: function() {
      this.update_code()
    },
    text_weight_th: function() {
      this.update_code()
    },
    text_weight_td: function() {
      this.update_code()
    },
    text_transform_th: function() {
      this.update_code()
    },
    text_transform_td: function() {
      this.update_code()
    },
    text_style_th: function() {
      this.update_code()
    },
    text_style_td: function() {
      this.update_code()
    },
    text_align_th: function() {
      this.update_code()
    },
    text_align_td: function() {
      this.update_code()
    },
    font_family_th: function() {
      this.update_code()
    },
    font_family_td: function() {
      this.update_code()
    },
    text_color_th: function() {
      this.update_code()
    },
    text_color_td: function() {
      this.update_code()
    },
    background_color_th: function() {
      this.update_code()
    },
    background_color_td: function() {
      this.update_code()
    },
    gradient_bg: function() {
      this.update_code()
    }
  },
}
</script>

<style>

</style>
